export default __webpack_public_path__ + "static/media/flag-malawi.d9774cd2.svg";